module.exports = __webpack_public_path__ + "static/media/project-img6.df5c8c82.png";